// src/Footer.jsx
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaEnvelope } from 'react-icons/fa';
import SnapConXIcon from './assets/SnapConX-icon.png';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Branding Section */}
          <div className="footer-branding">
            <div className="footer-logo-title">
              <img src={SnapConXIcon} alt="SnapConX Logo" className="footer-icon" />
              <span className="app-name">SnapConX</span>
            </div>
            <p className="footer-tagline">Connect • Share • Engage</p>
            <p className="footer-description">
              Empowering service providers and clients to connect seamlessly.
            </p>
            
            {/* Social Links */}
            <div className="footer-social">
              <a 
                href="mailto:info@dotanddash.co.za" 
                aria-label="Email"
                className="footer-social-icon"
              >
                <FaEnvelope />
              </a>
              <a 
                href="https://facebook.com/profile.php?id=61575813950330" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
                className="footer-social-icon"
              >
                <FaFacebookF />
              </a>
              <a 
                href="https://linkedin.com/company/snapconx" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="LinkedIn"
                className="footer-social-icon"
              >
                <FaLinkedinIn />
              </a>
              <a 
                href="https://instagram.com/snapconx" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Instagram"
                className="footer-social-icon"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>

          {/* Help & Support */}
          <div className="footer-section">
            <h4>Help & Support</h4>
            <Link to="/FAQ">FAQ</Link>
            <a href="mailto:info@dotanddash.co.za">Contact Support</a>
            <Link to="/guide">User Guides</Link>
            <Link to="/feedback">Send Feedback</Link>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Get In Touch</h4>
            <a href="mailto:info@dotanddash.co.za" className="footer-contact">
              info@dotanddash.co.za
            </a>
            <p className="footer-hours">
              Support Hours:<br />
              Mon-Fri: 9:00 AM - 5:00 PM
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} Dot and Dash Trading CC. All rights reserved.
          </p>
          <p className="footer-made">
            Made with ❤️ in South Africa
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;